import React, { useMemo } from 'react';
import { EDITABLE_MARKET_CHANNELS } from '../billingAndPayments.constants';
import { MY_ACCOUNT } from '../../../../constants';
import { ENTRY_POINT } from '../../../../services/mixpanel.constants';

import { PolicyHeader } from '../../../insurance/PolicyHeader';
import BillingInfoScreen from '../BillingInfoScreen';
import { Iframe } from '../../../common/iframe/Iframe';

import '../css/BillingDetailsScreen.css';

const BillingDetailsScreen = ({ breadCrumbs }) => {
  const breadCrumbsInfo = useMemo(() => {
    const response = {
      entryPoint: ENTRY_POINT.myAccount,
      marketingChannelId: 0,
      policyId: 0,
      policyNumber: '',
      webViewData: { title: '', url: '' },
    };

    if (breadCrumbs) {
      const breadCrumbsData = breadCrumbs.navData.find((data) => data.id
        === MY_ACCOUNT.billingAndPaymentDetails).extraData;

      response.entryPoint = breadCrumbsData?.entryPoint
        || ENTRY_POINT.myAccount;
      response.marketingChannelId = breadCrumbsData?.marketingChannelId || 0;
      response.policyId = breadCrumbsData?.policyId || 0;
      response.policyNumber = breadCrumbsData?.policyNumber || '';
      response.webViewData.title = breadCrumbsData?.title || '';
      response.webViewData.url = breadCrumbsData?.url || '';
    }

    return response;
  }, [breadCrumbs]);

  if (EDITABLE_MARKET_CHANNELS.includes(breadCrumbsInfo.marketingChannelId)) {
    return (
      <BillingInfoScreen
        entryPoint={breadCrumbsInfo.entryPoint}
        policyId={breadCrumbsInfo.policyId}
        policyNumber={breadCrumbsInfo.policyNumber}
      />
    );
  }

  return (
    <div className={'Billing-details-webview-header'
      + ` Colors-${breadCrumbsInfo.marketingChannelId}`}
    >
      <PolicyHeader company={breadCrumbsInfo.marketingChannelId} />

      <div className="Billing-details-webview-container">
        <Iframe
          className="Billing-details-webview"
          src={breadCrumbsInfo.webViewData.url}
          title={breadCrumbsInfo.webViewData.title}
        />
      </div>
    </div>
  );
};

export { BillingDetailsScreen };
